module.exports = __webpack_public_path__ + "static/media/YB5F02_1.b52dd2e8.jpg";